import { FETCH_EVENT_STATS } from '../actions/actionTypes';

const preState = { byEvent: {} };

const statsReducer = (state = preState, action) => {
	Object.freeze(state);
	const { type, eventID, stats } = action;

	switch (type) {
		case FETCH_EVENT_STATS:
			return { ...state, byEvent: { ...state.byEvent, [eventID]: stats } };
		default:
			return state;
	}
};

export default statsReducer;
